<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12 col-md-6">
    <app-checkbox-form-field
      formControlName="engageStc"
      [label]="'case.fields.engageStc.label' | translate"
      [helpText]="'case.fields.engageStc.help'"
      [viewMode]="viewMode"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-datepicker-form-field
      formControlName="engageStcDate"
      [label]="'case.fields.engageStcDate.label' | translate"
      [helpText]="'case.fields.engageStcDate.help'"
      [viewMode]="viewMode"
    ></app-datepicker-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-configuration-select-form-field
      formControlName="stcRegionLocation"
      [label]="'case.fields.stcRegionLocation.label' | translate"
      [helpText]="'case.fields.stcRegionLocation.help'"
      [placeholder]="'placeholders.please_select'"
      [clearable]="true"
      [searchable]="true"
      [externalSearch]="true"
      [viewMode]="viewMode"
      [params]="{
        type: dropdownStcRegionLocationType,
        entry1: form.get('stcRegionLocation')?.value || ''
      }"
      [entry]="'entry1'"
      [isRequired]="isStcRegionRequired"
    ></app-configuration-select-form-field>
  </div>
  <div class="col-12 col-md-6">
    <app-input-form-field
      formControlName="stcAdditionalInfo"
      [label]="'case.fields.stcAdditionalInfo.label' | translate"
      [helpText]="'case.fields.stcAdditionalInfo.help'"
      [viewMode]="viewMode"
    ></app-input-form-field>
  </div>
</div>
